import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import StockInService from "../services/StockInService";
import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService";
import Loading from "../components/loading";
import UnAuthorized from "../views/Unathorized";
import ReactPaginate from "react-paginate";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";
import { configSettings } from "../config/configSettings";
import { useReactToPrint } from "react-to-print";
import logo from "../assets/images/deviops_logo.png";

export default function ViewStockIn() {
  const [invoices, setInvoices] = useState([]);
  const [selected, setSelected] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [msgType, setMsgType] = useState("");
  const navigate = useNavigate();
  // const messageTimer = useRef(null);
  const roleId = StorageService.loginData().roleId;

  const companyId = StorageService.activeCompany().companyId;
  const employeeId = StorageService.loginData().employeeId;

  const [showDetails, setShowDetails] = useState(false);
  const [header, setHeader] = useState(null);

  const [selectedId, setSelectedId] = useState(null);
  const [detailRows, setDetailRows] = useState([]);
  const [detailsLoading, setDetailsLoading] = useState(false);
  // APPROVE MODAL
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveItem, setApproveItem] = useState(null);
  const [approveNote, setApproveNote] = useState("");

  // REJECT MODAL
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectItem, setRejectItem] = useState(null);
  const [rejectNote, setRejectNote] = useState("");

  // CANCEL MODAL
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelItem, setCancelItem] = useState(null);

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [allInvoices, setAllInvoices] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const [search, setSearch] = useState("");
  const [projectList, setProjectList] = useState([]);

  const companyName = StorageService.activeCompany()?.companyName || "Devi Projects";
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Stock_In_${header?.vocherNo || header?.invoiceNo || ""}`,
  });

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const pRes = await ProjectService.getActive(companyId);
        const pData = pRes?.data || pRes || [];
        setProjectList(Array.isArray(pData) ? pData : []);
      } catch (e) {
        console.error("Failed to load projects:", e);
      }
    };
    if (companyId) {
      fetchProjects();
    }
  }, [companyId]);

  const formatProjectDisplay = (project) => {
    if (!project) return "-";
    let projObj = project;
    if (typeof project === "string" || typeof project === "number") {
      const match =
        projectList.find(
          (p) =>
            String(p.id) === String(project) ||
            String(p.projectId) === String(project) ||
            p.projectName === project
        ) || {};
      projObj = Object.keys(match).length ? match : { projectName: String(project) };
    }

    const projectId = projObj.projectId || projObj.id;
    const matchedProject =
      (projectId &&
        projectList.find(
          (p) => String(p.id) === String(projectId) || String(p.projectId) === String(projectId)
        )) ||
      (projObj.projectName &&
        projectList.find((p) => p.projectName === projObj.projectName)) ||
      {};

    const projectName =
      projObj.projectName || projObj.name || matchedProject.projectName || "";
    const categoryName =
      projObj.projectCategoryName ||
      projObj.categoryName ||
      projObj.category ||
      matchedProject.projectCategoryName ||
      matchedProject.categoryName ||
      matchedProject.category ||
      "";
    const projectCode =
      projObj.projectCode || matchedProject.projectCode || "";
    const categoryInitial = String(categoryName).trim().charAt(0).toUpperCase();

    if (projectName) {
      if (categoryInitial) {
        return `${categoryInitial}*${projectName}`;
      }
      if (projectCode) {
        const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${projectName}`;
      }
      return projectName;
    }
    if (projectCode) {
      const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
      return `${codeInitial}*`;
    }
    return categoryInitial ? `${categoryInitial}*` : "-";
  };



  const itemsPerPage = 10;

  useEffect(() => {

    const delayDebounce = setTimeout(() => {

      setCurrentPage(1);
      setSearch(searchText);

    }, 400);

    return () => clearTimeout(delayDebounce);

  }, [searchText]);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);


  // const showMessage = (text, type = "error") => {
  //   setMessage(text);
  //   setMsgType(type);
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  //   messageTimer.current = setTimeout(() => setMessage(""), 4000);
  // };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const { permission, can } = usePermission(
    ScreenData.Stock_In,
    showMessage
  );
  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };
  // useEffect(() => {
  //   let mounted = true;
  //   setLoading(true);



  //   StockInService.getAll(companyId)
  // .then((res) => {
  //   if (!mounted) return;

  //   const data = res?.data?.data || [];

  //   data.sort(
  //     (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
  //   );

  //   setInvoices(data);
  //   setSelectedId(null);
  //   setSelected((prev) =>
  //     prev.filter((id) => data.some((d) => d.id === id))
  //   );
  // })
  // .catch((err) => console.error("GET ALL ERROR:", err))
  // .finally(() => mounted && setLoading(false));

  //   return () => {
  //     mounted = false;
  //     if (messageTimer.current) clearTimeout(messageTimer.current);
  //   };
  // }, [companyId]);

  useEffect(() => {

    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }
    let mounted = true;
    setLoading(true);

    if (!companyId || !employeeId) {
      console.warn("Missing companyId or employeeId", { companyId, employeeId });
      setLoading(false);
      return;
    }

    StockInService.getAll(
      companyId,
      employeeId,
      roleId,
      1,
      1000,
      search,
      statusFilter
    )
      .then((res) => {
        if (!mounted) return;

        console.log("API RESPONSE:", res?.data);

        const data = res?.data?.data || [];

        data.sort(
          (a, b) => new Date(b.createdDate) - new Date(a.createdDate)
        );

        setAllInvoices(data);
        const totalPages = Math.max(1, Math.ceil(data.length / itemsPerPage));
        setPageCount(totalPages);
        const safePage = Math.min(currentPage, totalPages);
        if (safePage !== currentPage) {
          setCurrentPage(safePage);
        }
        const start = (safePage - 1) * itemsPerPage;
        const end = start + itemsPerPage;
        setInvoices(data.slice(start, end));
        setSelectedId(null);
        setSelected((prev) =>
          prev.filter((id) => data.some((d) => d.id === id))
        );
      })
      .catch((err) => {
        console.error("GET ALL ERROR:", err);
      })
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
      // if (messageTimer.current) clearTimeout(messageTimer.current);
    };
  }, [
    companyId,
    employeeId,
    roleId,
    currentPage,
    permission,
    search,
    statusFilter
  ]);

  useEffect(() => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    setInvoices(allInvoices.slice(start, end));
  }, [allInvoices, currentPage]);




  const handleToggleStatus = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to change status?"
    );

    if (!confirmed) return;

    try {
      const res = await StockInService.updateStatus(id, {
        updatedBy: employeeId
      });

      const newStatus = res?.data?.result?.newStatus;

      // Update UI immediately
      setInvoices((prev) =>
        prev.map((inv) =>
          inv.id === id ? { ...inv, status: newStatus } : inv
        )
      );

      showMessage(`Status updated to ${newStatus}`, "success");
    } catch (err) {
      console.error("STATUS UPDATE ERROR:", err);
      showMessage("Failed to update status", "error");
    }
  };

  const submitApprove = async () => {
    if (!approveNote.trim()) {
      showMessage("Please enter approval note");
      return;
    }

    try {
      await StockInService.approve(approveItem.id, {
        approvedBy: employeeId,
        approvedNotes: approveNote,
      });

      setInvoices(prev =>
        prev.map(inv =>
          inv.id === approveItem.id ? { ...inv, status: "APPROVED" } : inv
        )
      );

      showMessage("StockIn approved successfully", "success");
      setShowApproveModal(false);

    } catch (err) {
      console.error(err);
      showMessage(err.response?.data?.message || "Approval failed");
    }
  };


  const submitReject = async () => {
    if (!rejectNote.trim()) {
      showMessage("Please enter rejection note");
      return;
    }

    try {
      await StockInService.reject(rejectItem.id, {
        rejectedBy: employeeId,
        rejectedNotes: rejectNote,
      });

      setInvoices(prev =>
        prev.map(inv =>
          inv.id === rejectItem.id ? { ...inv, status: "REJECTED" } : inv
        )
      );

      showMessage("StockIn rejected successfully", "success");
      setShowRejectModal(false);

    } catch (err) {
      console.error(err);
      showMessage("Rejection failed");
    }
  };


  const submitCancel = async () => {
    try {
      await StockInService.cancel(cancelItem.id, {
        cancelledBy: employeeId,
      });

      setInvoices(prev =>
        prev.map(inv =>
          inv.id === cancelItem.id ? { ...inv, status: "CANCELLED" } : inv
        )
      );

      showMessage("StockIn cancelled successfully", "success");
      setShowCancelModal(false);

    } catch (err) {
      console.error(err);
      showMessage("Failed to cancel StockIn", "error");
    }
  };


  // const handleSelect = (id) =>
  //   setSelected((prev) =>
  //     prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
  //   );
  // const handleSelectAll = (e) =>
  //   setSelected(e.target.checked ? invoices.map((x) => x.id) : []);

  const handleAdd = () => navigate("/cpnl/StockIn/add");

  const handleModify = () => {
    if (!selectedId) {
      return showMessage("Please select one record to modify.");
    }

    const selectedRecord = invoices.find(inv => inv.id === selectedId);

    if (!selectedRecord) {
      return showMessage("Selected record not found.");
    }

    if (selectedRecord.status !== "PENDING") {
      return showMessage("Only PENDING records can be modified.");
    }

    navigate(`/cpnl/StockIn/add/${selectedId}`);
  };
  // const handleModify = () => {
  //   if (selected.length === 0)
  //     return showMessage("Please select one invoice to modify.");
  //   if (selected.length > 1)
  //     return showMessage("Please select only one invoice to modify.");
  //   navigate(`/cpnl/StockIn/add/${selected[0]}`);
  // };
  const handleView = () => {
    if (!selectedId)
      return showMessage("Please select one record to view details.");

    setShowDetails(true);
  };

  const formatDate = (date) => {
    return date ? utility.formatDateDDMMMYYYY(date) : "-";
  };
  // useEffect(() => {
  //   if (!showDetails || !selectedId) return;

  //   const loadDetails = async () => {
  //     try {
  //       setDetailsLoading(true);
  //       const res = await StockInService.getById(selectedId);
  //       const data = res?.data?.data || {};
  //       console.log(data);
  //       setDetailRows(data.details || []);
  //     } catch (err) {
  //       console.error("DETAIL LOAD ERROR:", err);
  //       setDetailRows([]);
  //     } finally {
  //       setDetailsLoading(false);
  //     }
  //   };

  //   loadDetails();
  // }, [showDetails, selectedId]);


  useEffect(() => {
    if (!showDetails || !selectedId) return;

    const loadDetails = async () => {
      try {
        setDetailsLoading(true);
        const res = await StockInService.getById(selectedId);

        const payload = res?.data?.data || res?.data || res || {};
        const selectedRecord =
          invoices.find((r) => r.id === selectedId) ||
          allInvoices.find((r) => r.id === selectedId) ||
          {};
        const mergedHeader = {
          ...selectedRecord,
          ...payload,
          projectName: payload.projectName || selectedRecord.projectName || "",
          projectCode: payload.projectCode || selectedRecord.projectCode || "",
          projectCategoryName:
            payload.projectCategoryName ||
            selectedRecord.projectCategoryName ||
            "",
          projectCategoryCode:
            payload.projectCategoryCode ||
            selectedRecord.projectCategoryCode ||
            "",
        };

        setHeader(mergedHeader);
        setDetailRows(payload.details || payload.stockInDetails || []);
      } catch (err) {
        console.error("DETAIL LOAD ERROR:", err);
        setDetailRows([]);
      } finally {
        setDetailsLoading(false);
      }
    };

    loadDetails();
  }, [showDetails, selectedId, invoices, allInvoices]);

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }


  const formatEmployee = (name, code) => {
    if (name && code) return `${name} (${code})`;
    return name || code || "-";
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock In" secondTitle="Inventory" />
      <div className="card p-3 bg-white shadow-sm">
        {/* {message && (
          <div
            className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
              } d-flex justify-content-between align-items-center w-100 mb-2 p-2`}
            style={{ borderRadius: 5 }}
          >
            <span>{message}</span>
            <button className="btn-close" onClick={closeMessage}></button>
          </div>
        )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />

        <div className="mb-3 pb-2 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2">
          {can("canAdd") && (
            <button
              className="btn btn-success me-2"
              onClick={handleAdd}
              disabled={loading}
            >
              <i class="ti ti-plus me-1"></i> Add
            </button>
          )}


          {can("canModify") && (
            <button
              className="btn btn-warning me-2"
              onClick={handleModify}
              disabled={
                loading ||
                !selectedId ||
                invoices.find(inv => inv.id === selectedId)?.status !== "PENDING"
              }
            >
              <i className="ti ti-edit me-1"></i> Modify
            </button>
          )}


          {can("canView") && (
            <button
              className="btn btn-primary me-2"
              onClick={handleView}
              disabled={loading}
            >
              <i class="ti ti-eye me-1"></i> View
            </button>
          )}

          <select
            className="form-select d-inline w-auto ms-2"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="ALL">All</option>
            <option value="PENDING">Pending</option>
            <option value="APPROVED">Approved</option>
            <option value="REJECTED">Rejected</option>
            <option value="CANCELLED">Cancelled</option>
          </select>

          <div className="d-flex align-items-center ms-auto">
            <div className="position-relative">

              <input
                type="text"
                className="form-control pe-5"
                placeholder="Search Project / Invoice No"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{ width: "280px" }}
              />

              <i
                className="ti ti-search position-absolute"
                style={{
                  right: "15px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d"
                }}
              ></i>

            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-striped table-bordered mb-0">
            <thead className="table-light">
              <tr>
                <th>Select</th>
                <th>Received Date</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th>Voucher No</th>
                <th>Project</th>
                <th>Store</th>
                <th>Vendor Category</th>
                <th>Vendor</th>
                <th>Vendor Location</th>
                <th>Transporter</th>
                <th>Receipt</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="14" className="text-center py-4">
                    <Loading />
                  </td>
                </tr>
              ) : invoices.length > 0 ? (
                invoices.map((inv) => (
                  <tr key={inv.id}>
                    <td>
                      <input
                        type="radio"
                        name="stockInSelect"
                        checked={selectedId === inv.id}
                        onChange={() => setSelectedId(inv.id)}
                      />
                    </td>

                    <td>{formatDate(inv.receivedDate)}</td>
                    <td>{inv.invoiceNo || "-"}</td>
                    <td>{formatDate(inv.invoiceDate)}</td>
                    <td>{inv.vocherNo || "-"}</td>
                    <td>{formatProjectDisplay(inv)}</td>
                    <td>{inv.storeName || "-"}</td>
                    <td>{inv.vendorCategoryName || "-"}</td>
                    <td>{inv.vendorName || "-"}</td>
                    <td>{inv.vendorStoreName || "-"}</td>
                    <td>{inv.transporterName || "-"}</td>
                    <td>
                      {inv.stockInReceipt ? (
                        <a
                          href={`${configSettings.mediaURL}/get/StockIn/${inv.stockInReceipt}`}
                          target="_blank"
                          rel="noreferrer"
                          className="btn btn-sm btn-outline-primary"
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>

                    <td>
                      <span
                        className={`badge ${inv.status === "PENDING"
                          ? "bg-info text-dark"
                          : inv.status === "APPROVED"
                            ? "bg-success"
                            : inv.status === "REJECTED"
                              ? "bg-danger"
                              : inv.status === "CANCELLED"
                                ? "bg-dark"
                                : "bg-secondary"
                          }`}
                      >
                        {inv.status}
                      </span>
                    </td>

                    <td className="text-center d-flex justify-content-center gap-2">

                      {can("canApprove") && (
                        <button
                          className="btn btn-success btn-sm"
                          title="Approve"
                          disabled={inv.status !== "PENDING"}
                          onClick={() => {
                            setApproveItem(inv);
                            setApproveNote("");
                            setShowApproveModal(true);
                          }}
                        >
                          <i className="ti ti-circle-check"></i>
                        </button>
                      )}

                      {can("canReject") && (
                        <button
                          className="btn btn-danger btn-sm"
                          title="Reject"
                          disabled={inv.status !== "PENDING"}
                          onClick={() => {
                            setRejectItem(inv);
                            setRejectNote("");
                            setShowRejectModal(true);
                          }}
                        >
                          <i className="ti ti-circle-x"></i>
                        </button>
                      )}

                      {can("canCancel") && (
                        <button
                          className="btn btn-secondary btn-sm"
                          title="Cancel"
                          disabled={inv.status !== "PENDING" || Number(inv.createdBy) !== Number(employeeId)}
                          onClick={() => {
                            setCancelItem(inv);
                            setShowCancelModal(true);
                          }}
                        >
                          <i className="ti ti-cancel"></i>
                        </button>
                      )}

                    </td>

                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14" className="text-center text-muted">
                    No invoices found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <ReactPaginate
            forcePage={Math.max(0, Math.min(currentPage - 1, Math.max(pageCount - 1, 0)))}
            breakLabel="..."
            nextLabel="Next >"
            previousLabel="< Previous"
            onPageChange={(e) => setCurrentPage(e.selected + 1)}
            pageCount={Math.max(1, pageCount)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            containerClassName="pagination-container"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            activeClassName="active"
          />
        </div>
      </div>

      {showDetails && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.55)",
          }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Stock In Item Details</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowDetails(false)}
                ></button>
              </div>

              {/* <div className="modal-body">
                {detailsLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : (

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>UOM</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailRows.length > 0 ? (
                        detailRows.map((r, i) => (
                          <tr key={i}>
                            <td>{r.itemName}-{r.itemCode}</td>
                            <td>{r.UOM}</td>
                            <td>{r.quantity}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Records Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div> */}

              <div className="modal-body">
                {detailsLoading ? (
                  <div className="text-center py-4">
                    <Loading />
                  </div>
                ) : (
                  <>
                    {header && (
                      <div className="row mb-3">
                        {/* <div className="col-md-4">
                          <strong>Invoice No:</strong> {header.invoiceNo || "-"}
                        </div>
                        <div className="col-md-4 mt-2">
                          <strong>Invoice Date:</strong> {formatDate(header.invoiceDate)}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Project:</strong> {header.projectName || "-"}
                        </div>
                        <div className="col-md-4 mt-2">
                          <strong>Store:</strong> {header.storeName || "-"}
                        </div>

                        <div className="col-md-6 mt-2">
                          <strong>Transporter:</strong> {header.transporterName || "-"}
                        </div>

                        <div className="col-md-4 mt-2">
                          <strong>Vehicle No:</strong> {header.vehicleNo || "-"}
                        </div> */}

                        <div className="row mb-3">

                          {/* 1. Project & 2. Store Name */}
                          <div className="col-md-6">
                            <strong>Project:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{formatProjectDisplay(header)}</span>
                          </div>
                          <div className="col-md-6">
                            <strong>Store Name:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.storeName || "-"}</span>
                          </div>

                          {/* 3. Supplier Name & 4. Supplier Location */}
                          <div className="col-md-6 mt-2">
                            <strong>Supplier Name:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.vendorName || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Supplier Location:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.vendorStoreName || header.vendorLocation || "-"}</span>
                          </div>

                          {/* 5. Invoice No & 6. Invoice Date */}
                          <div className="col-md-6 mt-2">
                            <strong>Invoice No:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.invoiceNo || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Invoice Date:</strong>{" "}
                            <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                              {formatDate(header.invoiceDate)}
                            </span>
                          </div>

                          {/* 7. Transporter & 8. Vehicle No */}
                          <div className="col-md-6 mt-2">
                            <strong>Transporter:</strong> {header.transporterName || "-"}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Vehicle No:</strong> {header.vehicleNo || "-"}
                          </div>

                          {/* 9. Received By & 10. Received Date */}
                          <div className="col-md-6 mt-2">
                            <strong>Received By:</strong> {formatEmployee(header.receivedByName || header.createdByName, header.receivedByCode || header.createdByCode)}
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Received Date:</strong>{" "}
                            <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>
                              {formatDate(header.receivedDate)}
                            </span>
                          </div>

                          {/* Status & Created By */}
                          <div className="col-md-6 mt-2">
                            <strong>Status:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.status ? header.status.toUpperCase() : "PENDING"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Created By:</strong> {formatEmployee(header.createdByName, header.createdByCode)}
                          </div>

                          {/* Conditional Action Notes */}
                          {header.status?.toUpperCase() === "APPROVED" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Approved By:</strong> {formatEmployee(header.approvedByName, header.approvedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Approved Notes:</strong> {header.approvedNotes || "-"}
                              </div>
                              {header.approvedDate && (
                                <div className="col-md-6 mt-2">
                                  <strong>Approved Date:</strong> {formatDate(header.approvedDate)}
                                </div>
                              )}
                            </>
                          )}

                          {header.status?.toUpperCase() === "REJECTED" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected By:</strong> {formatEmployee(header.rejectedByName, header.rejectedByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Rejected Notes:</strong> {header.rejectedNotes || "-"}
                              </div>
                            </>
                          )}

                          {header.status?.toUpperCase() === "CANCELLED" && (
                            <>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled By:</strong> {formatEmployee(header.cancelledByName, header.cancelledByCode)}
                              </div>
                              <div className="col-md-6 mt-2">
                                <strong>Cancelled Notes:</strong> {header.cancelledNotes || "-"}
                              </div>
                            </>
                          )}

                          {/* Voucher No & Notes */}
                          <div className="col-md-6 mt-2">
                            <strong>Voucher No:</strong> <span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{header.vocherNo || "-"}</span>
                          </div>
                          <div className="col-md-6 mt-2">
                            <strong>Notes:</strong> {header.stockInNotes || header.notes || "-"}
                          </div>

                        </div>


                      </div>
                    )}

                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Item Category</th>
                          <th>Item</th>
                          <th>UOM</th>
                          <th>Quantity</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailRows.length > 0 ? (
                          detailRows.map((r, i) => (
                            <tr key={i}>
                              <td>{r.itemCategoryName || "-"}</td>
                              <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.itemCode}</span></td>
                              <td>{r.UOM}</td>
                              <td><span style={{ fontWeight: 800, color: "#000", fontSize: "15px" }}>{r.quantity}</span></td>
                              <td>{r.notes || "-"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {/* PRINT TEMPLATE */}
                    <div style={{ display: "none" }}>
                      <div ref={printRef} className="print-container">

                        <div className="print-top-header">
                          <div className="print-top-left">
                            <img src={logo} alt="Logo" className="print-logo" />
                            <span className="print-company">{companyName}</span>
                          </div>
                          <div className="print-top-right">
                            <b>Printed Date:</b> {utility.formatExportDateTime(new Date())}
                          </div>
                        </div>

                        <h3 className="print-title">Stock In Slip</h3>

                        <table className="print-header">
                          <tbody>
                            <tr className="project-store-row">
                              <td><b>Project Name:</b> {formatProjectDisplay(header)}</td>
                              <td><b>Store Name:</b> {header?.storeName || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Supplier Name:</b> {header?.vendorName || "-"}</td>
                              <td><b>Supplier Location:</b> {header?.vendorStoreName || header?.vendorLocation || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Invoice No:</b> {header?.invoiceNo || "-"}</td>
                              <td><b>Invoice Date:</b> {formatDate(header?.invoiceDate)}</td>
                            </tr>

                            <tr>
                              <td><b>Voucher No:</b> {header?.vocherNo || "-"}</td>
                              <td><b>Received Date:</b> {formatDate(header?.receivedDate)}</td>
                            </tr>

                            <tr>
                              <td><b>Transporter:</b> {header?.transporterName || "-"}</td>
                              <td><b>Vehicle No:</b> {header?.vehicleNo || "-"}</td>
                            </tr>

                            <tr>
                              <td><b>Received By:</b> {formatEmployee(header?.receivedByName || header?.createdByName, header?.receivedByCode || header?.createdByCode)}</td>
                              <td><b>Created By:</b> {formatEmployee(header?.createdByName, header?.createdByCode)}</td>
                            </tr>

                            <tr>
                              <td><b>Status:</b> {header?.status ? header.status.toUpperCase() : "PENDING"}</td>
                              <td></td>
                            </tr>

                            {header?.status?.toUpperCase() === "APPROVED" && (
                              <>
                                <tr>
                                  <td><b>Approved By:</b> {formatEmployee(header?.approvedByName, header?.approvedByCode)}</td>
                                  <td><b>Approved Notes:</b> {header?.approvedNotes || "-"}</td>
                                </tr>
                                {header?.approvedDate && (
                                  <tr>
                                    <td><b>Approved Date:</b> {formatDate(header?.approvedDate)}</td>
                                    <td></td>
                                  </tr>
                                )}
                              </>
                            )}

                            {header?.status?.toUpperCase() === "REJECTED" && (
                              <tr>
                                <td><b>Rejected By:</b> {formatEmployee(header?.rejectedByName, header?.rejectedByCode)}</td>
                                <td><b>Rejected Notes:</b> {header?.rejectedNotes || "-"}</td>
                              </tr>
                            )}

                            {header?.status?.toUpperCase() === "CANCELLED" && (
                              <tr>
                                <td><b>Cancelled By:</b> {formatEmployee(header?.cancelledByName, header?.cancelledByCode)}</td>
                                <td><b>Cancelled Notes:</b> {header?.cancelledNotes || "-"}</td>
                              </tr>
                            )}

                            <tr>
                              <td colSpan="2"><b>Notes:</b> {header?.stockInNotes || header?.notes || "-"}</td>
                            </tr>
                          </tbody>
                        </table>

                        <table className="print-table">
                          <thead>
                            <tr>
                              <th className="text-center">S.No</th>
                              <th className="text-start">Item Category</th>
                              <th className="text-start">Item Code</th>
                              <th className="text-start">UOM</th>
                              <th className="text-end">Quantity</th>
                              <th className="text-start">Notes</th>
                            </tr>
                          </thead>

                          <tbody>
                            {detailRows.map((d, i) => (
                              <tr key={i}>
                                <td className="text-center">{i + 1}</td>
                                <td className="text-start">{d.itemCategoryName || "-"}</td>
                                <td className="text-start">{d.itemCode || d.itemName || "-"}</td>
                                <td className="text-start">{d.UOM || "-"}</td>
                                <td className="text-end">{d.quantity}</td>
                                <td className="text-start">{d.notes || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div style={{ marginTop: "60px", display: "flex", justifyContent: "space-between" }}>
                          <div>Received By Signature</div>
                          <div>Store Incharge Signature</div>
                          <div>Approved By Signature</div>
                        </div>

                      </div>
                    </div>
                  </>
                )}
              </div>


              <div className="modal-footer">
                <button
                  className="btn btn-success me-2"
                  onClick={handlePrint}
                >
                  <i className="ti ti-printer me-1"></i>
                  Print
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowDetails(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showApproveModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Approve Stock In</h5>

            <div className="mb-2">
              <label>Approval Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Approval Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={approveNote}
                onChange={(e) => setApproveNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary"
                onClick={() => setShowApproveModal(false)}>
                Cancel
              </button>

              <button className="btn btn-success"
                onClick={submitApprove}>
                Approve
              </button>
            </div>
          </div>
        </div>
      )}
      {showRejectModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "450px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Reject Stock In</h5>

            <div className="mb-2">
              <label>Rejection Date</label>
              <input
                className="form-control"
                value={utility.formatDateDDMMMYYYY(new Date())}
                disabled
              />
            </div>

            <div className="mb-3">
              <label>Rejection Note</label>
              <textarea
                className="form-control"
                rows="3"
                value={rejectNote}
                onChange={(e) => setRejectNote(e.target.value)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary"
                onClick={() => setShowRejectModal(false)}>
                Cancel
              </button>

              <button className="btn btn-danger"
                onClick={submitReject}>
                Reject
              </button>
            </div>
          </div>
        </div>
      )}
      {showCancelModal && (
        <div style={{
          position: "fixed",
          top: 0, left: 0,
          width: "100%", height: "100%",
          background: "rgba(0,0,0,0.5)",
          zIndex: 999
        }}>
          <div style={{
            position: "fixed",
            top: "50%", left: "50%",
            transform: "translate(-50%,-50%)",
            width: "400px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px"
          }}>
            <h5>Cancel Stock In</h5>

            <p>Are you sure you want to cancel this record?</p>

            <div className="d-flex justify-content-end gap-2">
              <button className="btn btn-secondary"
                onClick={() => setShowCancelModal(false)}>
                No
              </button>

              <button className="btn btn-dark"
                onClick={submitCancel}>
                Yes Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}